import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { IncomeService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { WhiteImage } from 'assets/img';
import { AddIcon, TrashIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
	type_id?: number;
	categories?: any[];
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			category_id: ''
		},
		subcategories: [{
			name: '',
			image: ''
		}]
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				subcategories: [
					{
						id: this.props.item?.id || '',
						name: this.props.item?.name || '',
						image: this.props.item?.image || ''
					}
				],
				form: {
					...this.state.form,
					category_id: this.props.item?.category_id || ''
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();	

		if (!this.state.form.category_id) {
			Globals.showError("Por favor, seleccione la categoría");
			return;
		}

		if (this.state.subcategories.length == 0) {
			Globals.showError("Debe crear al menos una subcategoría");
			return;
		}

		let item = this.state.subcategories?.find((i: any) => !i.name);

		if (item) {
			Globals.showError("Por favor, ingrese el nombre de todas las subcategorias");
			return;
		}

		item = this.state.subcategories?.find((i: any) => i.id == null && !i.image);

		if (item) {
			Globals.showError("Por favor, ingrese la imagen de todas las subcategorias");
			return;
		}

		let params: any = {
			type_id: this.props.type_id,
			...this.state.form,
			hasFile: true,
			subcategories: JSON.stringify(this.state.subcategories.map((item: any) => {
				return {
					id: item.id,
					name: item.name
				}
			}))
		}

		for (let i = 0; i < this.state.subcategories?.length; i++) {
			const subcategory: any = this.state.subcategories[i];

			if (subcategory?.image)
				params['subcategories_' + i] = subcategory?.image?.value;
		}

		await IncomeService.admin.save(params);
		this.props.onClose();
		Globals.showSuccess("Se han guardado las subcategorías correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		let subcategories: any = [...this.state.subcategories];
		subcategories.push({
			name: '',
			image: ''
		});
		this.setState({
			subcategories
		});
	}

	delete = (e: any, index: number) => {
		e.preventDefault();
		let subcategories: any = [...this.state.subcategories];
		subcategories.splice(index,1);
		this.setState({
			subcategories
		});
	}
	
	render() {
		return (
			<div id="modal-create-category">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-md-12">
						<p className="title-create">Seleccionar la categoría a la cual asignará la nueva subcategoría</p>
					</div>
					{
						this.props.categories?.map((item: any) => {
							return (
								<div className="col-md-4">
									<a href="#" className="link-category" onClick={ (e: any) => {
										e.preventDefault();
										this.setState({
											form: {
												...this.state.form,
												category_id: item?.id
											}
										});
									} }>
										<div className={ `container-circle ${ this.state.form.category_id == item?.id ? 'active' : '' }` }></div>
										<p>{ item?.name }</p>
									</a>
								</div>
							)
						})
					}
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-6">
								<p className="subcategory-title">Subcategoría</p>
							</div>
							{
								!this.props.item && (
									<div className="col-md-6 text-right">
										<button type="button" className="btn btn-add" onClick={ () => this.add() }>
											<img src={ AddIcon } />
											Agregar
										</button>
									</div>
								)
							}
						</div>
					</div>
					{
						this.state.subcategories?.map((item: any, index: number) => {
							return (
								<div className="col-md-12 row" style={{ marginBottom: '15px' }}>
									<div className="col-3">
										<PaperClip
											formats={['png', 'jpg', 'jpeg']}
											value={item.image}
											width={600}
											height={600}
											onChange={(e: any) => {
												let subcategories: any = [...this.state.subcategories];
												subcategories[index].image = e.target;
												this.setState({
													subcategories
												});
											}}>
											<div className="image">
												{/*
												// @ts-ignore */}
												<img className={ !item.image?.dataURL && !item.image ? `default-image` : '' } src={item.image?.dataURL || (item?.image && Constants.BASE_STORAGE + item?.image) || WhiteImage} />
											</div>
										</PaperClip>
									</div>
									<div className="col-8 container-input">
										<Input
											color="white"
											value={ item.name }
											name="name"
											placeholder="Nombre"
											onChange={ (e: any) => {
												let subcategories: any = [...this.state.subcategories];
												subcategories[index][e.target.name] = e.target.value;
												this.setState({
													subcategories
												});
											} } />
									</div>
									<div className="col-1 container-input">
										<a href="#" onClick={ (e: any) => this.delete(e,index) }>
											<img src={ TrashIcon } />
										</a>
									</div>
								</div>
							)
						})
					}
					<div className="col-md-12 text-center">
						<Button className="btn-submit" type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;